/** A UTXO as Cardano tooling writes it, `<transaction id>#<output index>`. */
export const utxoRef = (txId: string, index: number) => `${txId}#${index}`;
